import React from "react";
import "./styles.css";
import profileIcon from "../../../Assets/Images/PatientImg.png";
import { useAuth } from "../../../Context/AuthContext";
import { getDDMMYY, getTime } from "../../../Helpers";

const ChatBar = ({ message, patientDetails }) => {
  const { physician } = useAuth();

  return (
    <div
      className="chat-bar"
      // style={{
      //   alignItems: message.sentBy === "Patient" ? "flex-start" : "flex-end",
      // }}
    >
      <div
        className="chat-profile-info"
        // style={{
        //   flexDirection: message.sentBy === "Patient" ? "row" : "row-reverse",
        // }}
      >
        <div
          // className="profile-img white"
          className={`profile-img ${
            message.sentBy === "Patient"
              ? // "blue"
                "light-blue"
              : "white"
          }`}
          style={{
            border:
              message.sentBy === "Patient" &&
              // "2px solid var(--Light-Grey, #eaf0f7)",
              "2px solid var(--Light-Grey, #3058a6)",
            background:
              message.sentBy === "Patient" &&
              // "#eaf0f7",
              "#3058a6",
          }}
        >
          {" "}
          <h5 className="h5-400">
            {message.sentBy === "Patient"
              ? `${patientDetails.firstName[0] || patientDetails.lastName[0]}`
              : `${physician.firstName[0] || physician.lastName[0]}`}
          </h5>
        </div>
        <span>
          {message.sentBy === "Patient"
            ? `${patientDetails.firstName} ${patientDetails.lastName}`
            : `${physician.firstName} ${physician.lastName}`}
        </span>
        <span style={{ color: "#67727E" }}>
          {getDDMMYY(message.date)} {getTime(new Date(message.date))}
        </span>
      </div>
      <span
        className="chat-message"
        style={{ fontWeight: "400", lineHeight: "1.5" }}
      >
        {message.text}
      </span>
    </div>
  );
};

export default ChatBar;
